module.exports = __webpack_public_path__ + "static/media/Lauren Beckstedt Headshot.c2cf7043.jpeg";